// Shared layout constants used by the page templates and sidebars.

// Height of the top nav (`Header.tsx`). Page templates pin the header to
// this height; sidebar masks offset their top edge by the same value so
// the dimming layer doesn't cover the nav.
export const NAV_HEIGHT_PX = 48;

// Drop-shadow projected leftward from the right-anchored form sidebars.
// `border-0 shadow-lg` from the atomic-components Sidebar theme would
// otherwise apply a tighter drop-style shadow centred under the panel;
// this wash reads more like a soft elevation off the nav.
export const SIDEBAR_PANEL_SHADOW = '!shadow-[-24px_0_120px_rgba(0,0,0,0.18)]';

// Soft 4px-down 16px-blur drop used on dropdown / autocomplete panels.
export const FLOATING_PANEL_SHADOW = 'shadow-[0_4px_16px_rgba(0,0,0,0.12)]';
